import { Navigate } from 'react-router-dom';

const UserRedirect = () => <Navigate to='/customers' replace={true} />;

export { UserRedirect };
